// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Form,
  OverlayTrigger,
  Tooltip,
  Popover,
} from "react-bootstrap";
import AdminApi from "../../api/adminApi";
import { toast } from "react-toastify";
import { ResponsiveDataList } from "../../components/responsive";
import Helpers from "../../components/Helpers";
import { sortParishesByName } from "../../utils/parishLabels";
import DeleteModel from "../../components/DeleteModal";
import { useAuthUser } from "../../hooks/useAuthUser";
import { setBrokenImageFallback } from "../../utils/imageFallback";
import { isProtectedDemoCouple } from "../../utils/demoAccounts";
import { utils, writeFile } from "xlsx";
import AlertModal from "../../components/AlertModal";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Profile from "../../assets/images/couple-default.png";
import corruptedImg from "../../assets/images/corrupted-img.png";
import AuthApi from "../../api/authApi";
import UpdateCouplePopUp from "../Common/UpdateCouplePopUp";
import { useLocation } from "react-router-dom";
import { ManageCouplesHeaderActions } from "./Couples/manage/ManageCouplesHeaderActions";
import { ManageCouplesToolbar } from "./Couples/manage/ManageCouplesToolbar";
import { CoupleCard } from "./Couples/manage/cards/CoupleCard";
const XLSX = require("xlsx");

const ManageCouples = () => {
  const locationData = useLocation();
  const [validated, setValidated] = useState(false);
  const [showRegModal, setShowREgModal] = useState(false);
  const [isTempUpload, setIsTempUpload] = useState(false);
  const [data, setData] = useState({
    id: "",
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    imageUrl: "",
    parishId: null,
    address: "",
    allergies: "",
    anniversary_date: "",
    under_age_35: "NO",
    emergency_name1: "",
    emergency_relationship1: "",
    emergency_phone1: "",
    emergency_name2: "",
    emergency_relationship2: "",
    emergency_phone2: "",
    hear_us: [],
    referral_from_a_friend_or_family_member: "",
  });
  const [allCoupleData, setAllCoupleData] = useState<any[]>([]);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [total, setTotal] = useState(20);
  const [searchKey, setSearchKey] = useState("");
  const [show, setShow] = useState(false);
  const [icon_id, setIcon_id] = useState("");
  let adminApi = new AdminApi();
  let authApi = new AuthApi();
  const userData = useAuthUser();
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [changeText, setChangeText] = useState("");
  const [LoadData, setLoadData] = useState(false);
  const [roastersOfCoupleList, setRoastersOfCoupleList] = useState<any[]>([]);
  const [isEditAdmin, setIsEditAdmin] = useState(false);
  const [parishList, setParishList] = useState<any[]>([]);
  const [roasterCount, setRoasterCount] = useState("");
  const [oldValues, setOldValues] = useState<any[]>([]);
  const [makeSubAdminValue, setMakeSubAdminValue] = useState({
    value: "",
    coupleId: "",
    adminType: "",
  });
  const [alreadyPk, setAlreadyPk] = useState();
  const [coupleRepeatMsg, setCoupleRepeatMsg] = useState("");

  const path = locationData.pathname;
  const lastSegment = path.split("/").filter(Boolean).pop();

  useEffect(() => {
    const seeded = locationData?.state?.searchKeyword || "";
    setSearchKey(seeded);
    if (locationData?.state?.parishValue) {
      getAllCouplesData(
        1,
        20,
        seeded || null,
        {},
        false,
        locationData?.state?.parishValue,
      );
    } else {
      getAllCouplesData(1, 20, seeded || null, {}, false, null);
    }
    getParishList();
    
  }, []);

  useEffect(() => {
    const seeded = locationData?.state?.searchKeyword || "";
    setSearchKey(seeded);
    if (lastSegment === "missing-data") {
      getAllCouplesData(1, 20, seeded || null, {}, false, null);
    } else {
      if (locationData?.state?.parishValue) {
        getAllCouplesData(
          1,
          20,
          seeded || null,
          {},
          false,
          locationData?.state?.parishValue,
        );
      } else {
        getAllCouplesData(1, 20, seeded || null, {}, false, null);
      }
    }
  }, [lastSegment]);

  const checkPKCouple = async () => {
    await authApi
      .checkPKCouple()
      .then((res: any) => {
        if (res.success) {
          if (res.data != null) {
            let incPK = res.data + 1;
            setAlreadyPk(incPK);
            let d = { ...data };
            d.primaryKey = incPK;
            setData(d);
          } else {
            let defaultPK = 1001;
            setAlreadyPk(defaultPK);
            let d = { ...data };
            d.primaryKey = defaultPK;
            setData(d);
          }
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getParishList = async () => {
    setLoadData(true);
    await authApi
      .getPerishList()
      .then((response: any) => {
        setParishList(sortParishesByName(response.data));
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const clearfield = () => {
    setData({
      id: "",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      hisMobile: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
      herMobile: "",
      city: "",
      state: "",
      zip: "",
      notes: "",
      imageUrl: "",
      parishId: null,
      address: "",
      allergies: "",
      anniversary_date: "",
      under_age_35: "NO",
      emergency_name1: "",
      emergency_relationship1: "",
      emergency_phone1: "",
      emergency_name2: "",
      emergency_relationship2: "",
      emergency_phone2: "",
      hear_us: [],
      referral_from_a_friend_or_family_member: "",
    });
    setValidated(false);
  };

  const getAllCouplesData = async (pageNo: any = 1, size: any = 20, searchKeyword: any = null, sortBy: any = {}, loadCount: any = false, parishValue: any = null, 
  ) => {
    setLoadData(true);
    let d = { userRole: "COUPLE" };
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    }
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    }
    if (parishValue) {
      d.parishValue = parishValue;
    }
    if (lastSegment === "missing-data") {
      d.withoutParishCouples = true;
    }

    d.export = false;
    await adminApi
      .getAllCouples(d)
      .then((res: any) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setTotal(totalRecords);
          setAllCoupleData(res.data);
          setLoadData(false);
        } else {
          setLoadData(false);
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        setLoadData(false);
        toast.error(error);
      });
  };

  const allCouples = async () => {
    getAllCouplesData();
  };

  const missingCouples = async () => {
    await adminApi
      .getMissingData()
      .then((res: any) => {
        if (res.success) {
          setAllCoupleData(res.data);
          setTotal(res.totalRecords);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        console.error("There is an error!", error);
        toast.error(error);
      });
  };

  const handleSearchChanges = async (e: any) => {
    let { name, value } = e.target;
    if (e.target.value === "0") {
      allCouples();
      
    } else if (e.target.value === "1") {
      
      missingCouples();
    }
  };

  const getroastersOfCouple = async (id: any) => {
    await adminApi
      .participatedInRetreats({ couple_Id: id })
      .then(async (response: any) => {
        setRoastersOfCoupleList(response.data);
        setRoasterCount(response.totalRecords);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const editCouple = async (id: any) => {
    setIsTempUpload(false);
    // setIsTempUpload2(false);
    setEdiUserIdClicked(id);
    let d = { ...data };
    await adminApi
      .getCouplesDetail({ coupleId: id })
      .then(async (res: any) => {
        if (isProtectedDemoCouple(res.data[0].hisEmail, res.data[0].herEmail)) {
          setIsEditAdmin(true);
        }
        if (res.success) {
          d.id = res.data[0].id;
          d.primaryKey = res.data[0].primaryKey;
          d.hisFirstName = res.data[0].hisFirstName;
          d.hisLastName = res.data[0].hisLastName;
          d.hisEmail = res.data[0].hisEmail;
          d.hisMobile = res.data[0].hisMobile;
          d.herFirstName = res.data[0].herFirstName;
          d.herLastName = res.data[0].herLastName;
          d.herEmail = res.data[0].herEmail;
          d.herMobile = res.data[0].herMobile;
          d.city = res.data[0].city;
          d.state = res.data[0].state;
          d.zip = res.data[0].zip;
          d.notes = res.data[0].notes;
          d.parishId = res.data[0].parishId;
          d.imageUrl = res.data[0].imageUrl;
          d.address = res.data[0].address;
          d.allergies = res.data[0].allergies;
          d.anniversary_date = res.data[0].anniversary_date
            ? new Date(res.data[0].anniversary_date)
            : "";
          d.under_age_35 = res.data[0].under_age_35;
          d.emergency_name1 = res.data[0].emergency_name1;
          d.emergency_relationship1 = res.data[0].emergency_relationship1;
          d.emergency_phone1 = res.data[0].emergency_phone1;
          d.emergency_name2 = res.data[0].emergency_name2;
          d.emergency_relationship2 = res.data[0].emergency_relationship2;
          d.emergency_phone2 = res.data[0].emergency_phone2;
          d.hear_us = res.data[0].hear_us;
          d.referral_from_a_friend_or_family_member =
            res.data[0].referral_from_a_friend_or_family_member;
          setData(d);
          setOldValues(res.data[0]);
          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const deleteCouple = async () => {
    await adminApi
      .deleteCouple({ couple_id: icon_id.id })
      .then(async (res: any) => {
        if (res.success) {
          getAllCouplesData();
          setShow(false);
          setIcon_id("");
          checkPKCouple();
          toast.success(res.msg);
          
        } else {
          checkPKCouple();
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const popover = (row: any) => {
    return (
      <Popover id="popover-ImgPk" bsPrefix="popover">
        <Popover.Body>
          <div style={{ textAlign: "center", padding: "10px 0px" }}>
            {row.imageUrl ? (
              <span>
                <img
                  src={row.imageUrl}
                  className="column-rowImagePopover"
                  onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                />
              </span>
            ) : (
              <img src={Profile} className="column-rowImagePopover" />
            )}
            <h6 className="couplename">
              {" "}
              {row &&
                row.hisLastName +
                  ", " +
                  row.hisFirstName +
                  " and " +
                  row.herFirstName}
            </h6>
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const columns = [
    ...(userData && userData.userRole === "ADMIN"
      ? [
          {
            id: "action",
            name: "Action",
            button: true,
            cell: (row) => (
              <>
                <button
                  className="font-size"
                  onClick={() => {
                    editCouple(row.id);
                    setShowREgModal(true);
                    getroastersOfCouple(row.id);
                  }}
                >
                  <i
                    className="mdi mdi-pencil-box text-lg text-primary font-size"
                    title="Edit"
                  ></i>
                </button>
                <button className="font-size" onClick={() => handleShow(row)}>
                  <i
                    className="mdi mdi-delete-forever text-md text-danger mx-2 font-size"
                    title="Delete"
                  ></i>
                </button>
              </>
            ),
            reorder: true,
          },
        ]
      : []),
    {
      id: "primaryKey",
      name: "Couple Id",
      selector: (row) => row.primaryKey,
      cell: (row) => (
        <OverlayTrigger placement="right" overlay={popover(row)}>
          {row.imageUrl ? (
            <span
              onClick={() => {
                editCouple(row.id);
                setShowREgModal(true);
                getroastersOfCouple(row.id);
              }}
            >
              <span className="roasterKey">
                {" "}
                <img
                  src={row.imageUrl}
                  className="column-rowImage"
                  onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                />
              </span>
              {row.primaryKey && row.primaryKey}
            </span>
          ) : (
            <span
              onClick={() => {
                editCouple(row.id);
                setShowREgModal(true);
                getroastersOfCouple(row.id);
              }}
            >
              <span className="roasterKey">
                {" "}
                <img src={Profile} className="column-rowImage-profile" />
              </span>

              {row.primaryKey && row.primaryKey}
            </span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "hisLastName",
      name: "His Last Name",
      selector: (row) => row.hisLastName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisLastName)}
        >
          <span
            onClick={() => {
              editCouple(row.id);
              setShowREgModal(true);
              getroastersOfCouple(row.id);
            }}
          >
            {row.hisLastName &&
              row.hisLastName.slice(0, 10) +
                (row.hisLastName.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#E0F8FE",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "hisFirstName",
      name: "His First Name",
      selector: (row) => row.hisFirstName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisFirstName)}
        >
          <span
            onClick={() => {
              editCouple(row.id);
              setShowREgModal(true);
              getroastersOfCouple(row.id);
            }}
          >
            {row.hisFirstName &&
              row.hisFirstName.slice(0, 10) +
                (row.hisFirstName.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#E0F8FE",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "hisEmail",
      name: "His Email",
      selector: (row) => row.hisEmail,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisEmail)}
        >
          <a href={`mailto:${row.herEmail}`}>
            <span>
              {row.hisEmail &&
                row.hisEmail.slice(0, 12) +
                  (row.hisEmail.length > 12 ? "..." : "")}
            </span>
          </a>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#E0F8FE",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
      style: {
        backgroundColor: "#E0F8FE",
        cursor: "text",
      },
    },
    {
      id: "hisMobile",
      name: "His Mobile",
      selector: (row) => row.hisMobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.hisMobile)}
        >
          <span>
            {row.hisMobile &&
              row.hisMobile.slice(0, 10) +
                (row.hisMobile.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#E0F8FE",
        cursor: "text",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "herLastName",
      name: "Her Last Name",
      selector: (row) => row.herLastName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herLastName)}
        >
          <span
            onClick={() => {
              editCouple(row.id);
              setShowREgModal(true);
              getroastersOfCouple(row.id);
            }}
          >
            {row.herLastName &&
              row.herLastName.slice(0, 10) +
                (row.herLastName.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#FFEDFB",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "herFirstName",
      name: "Her First Name",
      selector: (row) => row.herFirstName,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herFirstName)}
        >
          <span
            onClick={() => {
              editCouple(row.id);
              setShowREgModal(true);
              getroastersOfCouple(row.id);
            }}
          >
            {row.herFirstName &&
              row.herFirstName.slice(0, 10) +
                (row.herFirstName.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#FFEDFB",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "herEmail",
      name: "Her Email",
      selector: (row) => row.herEmail,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herEmail)}
        >
          <a href={`mailto:${row.herEmail}`}>
            <span>
              {row.herEmail &&
                row.herEmail.slice(0, 12) +
                  (row.herEmail.length > 12 ? "..." : "")}
            </span>
          </a>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#FFEDFB",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "herMobile",
      name: "Her Mobile",
      selector: (row) => row.herMobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.herMobile)}
        >
          <span>
            {row.herMobile &&
              row.herMobile.slice(0, 10) +
                (row.herMobile.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        backgroundColor: "#FFEDFB",
        cursor: "text",
      },
      conditionalCellStyles: [
        {
          when: (row) => row.accountStatus !== "ACTIVE",
          style: {
            backgroundColor: "#f8d7da",
            color: "#000",
            borderColor: "#dfc2c4",
          },
        },
      ],
    },
    {
      id: "Address",
      name: "Address",
      selector: (row) => row.address,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.address)}
        >
          <span>
            {row.address &&
              row.address.slice(0, 10) + (row.address.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Parish",
      name: "Parish",
      selector: (row) => row.parish,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.parish)}
        >
          <span>{row.parish}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "220px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "city",
      name: "City",
      selector: (row) => row.city,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.city)}
        >
          <span>
            {row.city &&
              row.city.slice(0, 10) + (row.city.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "state",
      name: "State",
      selector: (row) => row.state,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.state)}
        >
          <span>
            {row.state &&
              row.state.slice(0, 10) + (row.state.length > 10 ? "..." : "")}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "zip",
      name: "Zip",
      selector: (row) => row.zip,
      sortable: true,
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "Anniversary Date",
      name: "Anniversary Date",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY"),
          )}
        >
          <span>
            {row.anniversary_date
              ? Helpers.convertUtcToTimezone(row.anniversary_date, "M/D/YYYY")
              : "--"}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "DD-MM-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      style: {
        cursor: "text",
      },
    },
    ...(userData && userData.userRole === "SUBADMIN"
      ? [
          {
            id: "status",
            name: "Status",
            selector: (row) =>
              row.accountStatus.charAt(0).toUpperCase() +
              row.accountStatus.slice(1),
            reorder: true,
          },
        ]
      : []),
    ...(userData && userData.userRole === "ADMIN"
      ? [
          {
            id: "status",
            name: "Status",
            selector: (row) =>
              row.accountStatus.charAt(0).toUpperCase() +
              row.accountStatus.slice(1),
            cell: (row) => (
              <Form.Select
                size="sm"
                value={row.accountStatus}
                onChange={(e) => changeStatus(row.id, e.target.value)}
                className="selectData"
              >
                <option value="ACTIVE">Active</option>
                <option value="DECEASED">Deceased</option>
                <option value="DIVORCED">Divorced</option>
                <option value="INACTIVE">Inactive</option>
              </Form.Select>
            ),
            reorder: true,
          },
          {
            id: "makeSubAdmin",
            name: "Sub Admin?",
            selector: (row) => {
              if (
                row.accountStatus === "ACTIVE" &&
                (row.hisEmail || row.herEmail)
              ) {
                if (
                  row.hisEmail !== "tkolkebeck@me.com" &&
                  row.herEmail !== "tkolkebeck@satx.rr.com" &&
                  row.hisEmail !== "jimmieflores@gmail.com" &&
                  row.herEmail !== "dulceaflores@gmail.com"
                ) {
                  return (
                    <Form.Check
                      className="switchSize"
                      type="switch"
                      name="makeCoupleAsSubAdmin"
                      value={row.isAdminRight}
                      checked={row.isAdminRight}
                      onChange={(e) => {
                        handleShow1(e.target.value, row, "SUBADMIN");
                      }}
                      id="makeCoupleAsSubAdmin"
                    />
                  );
                }
              }
            },
            reorder: true,
          },
          {
            id: "makeAdmin",
            name: "Super Admin?",
            selector: (row) => {
              if (
                row.accountStatus === "ACTIVE" &&
                (row.userRole === "SUBADMIN" || row.userRole === "ADMIN")
              ) {
                if (
                  row.hisEmail !== "tkolkebeck@me.com" &&
                  row.herEmail !== "tkolkebeck@satx.rr.com" &&
                  row.hisEmail !== "jimmieflores@gmail.com" &&
                  row.herEmail !== "dulceaflores@gmail.com"
                ) {
                  return (
                    <Form.Check
                      className="switchSize"
                      type="switch"
                      name="makeCoupleAsAdmin"
                      value={row.userRole === "ADMIN" ? 1 : 0}
                      checked={row.userRole === "ADMIN" ? 1 : 0}
                      onChange={(e) => {
                        handleShow2(e.target.value, row, "ADMIN");
                      }}
                      id="makeCoupleAsAdmin"
                    />
                  );
                }
              }
            },
            reorder: true,
          },
        ]
      : []),
  ];

  const changeStatus = (id, value) => {
    adminApi
      .changeStatus({ id: id, value: value })
      .then((res: any) => {
        getAllCouplesData();
        

        toast.success(res.msg);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const makeCoupleAsSubAdmin = () => {
    if (
      makeSubAdminValue &&
      makeSubAdminValue.value !== "" &&
      makeSubAdminValue.coupleId !== ""
    ) {
      let value;
      if (makeSubAdminValue.value === "1") {
        value = 0;
      } else {
        value = 1;
      }
      adminApi
        .makeCoupleAsSubAdmin({
          value: value,
          id: makeSubAdminValue.coupleId,
          adminType: makeSubAdminValue.adminType,
        })
        .then((res: any) => {
          

          getAllCouplesData();
          toast.success(res.msg);
          handleClose1();
          handleClose2();
        })
        .catch((error: any) => {
          toast.error(error);
          let d = { ...makeSubAdminValue };
          d.value = "";
          d.coupleId = "";
          d.adminType = "";
          setMakeSubAdminValue(d);
        });
    }
  };

  const handleShow1 = (value, row, adminType) => {
    if (row.isAdminRight) {
      setChangeText("remove");
    } else {
      setChangeText("");
    }
    setShow1(true);
    let d = { ...makeSubAdminValue };
    d.value = value;
    d.coupleId = row.id;
    d.adminType = adminType;
    setMakeSubAdminValue(d);
  };

  const handleShow2 = (value, row, adminType) => {
    if (row.isAdminRight && row.userRole == "ADMIN") {
      setChangeText("remove");
    } else {
      setChangeText("");
    }
    setShow2(true);
    let d = { ...makeSubAdminValue };
    d.value = value;
    d.coupleId = row.id;
    d.adminType = adminType;
    setMakeSubAdminValue(d);
  };

  const handleShow = (item) => {
    setShow(true);
    setIcon_id(item);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleClose1 = () => {
    setChangeText("");
    setShow1(false);
    let d = { ...makeSubAdminValue };
    d.value = "";
    d.coupleId = "";
    d.adminType = "";
    setMakeSubAdminValue(d);
  };

  const handleClose2 = () => {
    setChangeText("");
    setShow2(false);
    let d = { ...makeSubAdminValue };
    d.value = "";
    d.coupleId = "";
    d.adminType = "";
    setMakeSubAdminValue(d);
  };

  const handleClose3 = () => {
    setShow3(false);
  };

  const CloseCompose = () => {
    setIsEditAdmin(false);
    setValidated(false);
    setShowREgModal(false);
    setEdiUserIdClicked("");
    clearfield();
  };

  const SearchData = (event) => {
    const key = event.target.value;
    if (key !== "") {
      setSearchKey(event.target.value);
      getAllCouplesData(
        1,
        20,
        event.target.value,
        {},
        false,
        locationData?.state?.parishValue,
      );
    } else {
      setSearchKey("");
      getAllCouplesData(1, 20, "", {}, false, locationData?.state?.parishValue);
    }
  };

  const conditionalRowStyles = [
    {
      when: (row) =>
        row.accountStatus === "DECEASED" ||
        row.accountStatus === "DIVORCED" ||
        row.accountStatus === "INACTIVE",
      style: {
        backgroundColor: "#f8d7da",
        color: "#000",
        borderColor: "#dfc2c4",
      },
    },
  ];

  const handleExport = async () => {
    let d = { userRole: "COUPLE" };
    d.pageNo = 1;
    d.size = 20;
    d.export = true;
    await adminApi
      .getAllCouples(d)
      .then(async (res) => {
        if (res.success) {
          let exportData = [];
          res.data.forEach((element) => {
            exportData.push({
              primaryKey: element.primaryKey,
              hisFirstName: element.hisFirstName,
              hisLastName: element.hisLastName,
              hisEmail: element.hisEmail,
              hisMobile: element.hisMobile,
              herFirstName: element.herFirstName,
              herLastName: element.herLastName,
              herEmail: element.herEmail,
              herMobile: element.herMobile,
              address: element.address,
              city: element.city,
              state: element.state,
              zip: element.zip,
              parish: element.parish,
              Anniversary_date:
                element.anniversary_date !== null
                  ? Helpers.convertUtcToTimezone(
                      element.anniversary_date,
                      "MM-DD-YYYY",
                    )
                  : "",
              Dietary_restrictions_or_physical_limitations: element.allergies,
              Under_age_35: element.under_age_35,
              Emergency_name1: element.emergency_name1,
              Emergency_relationship1: element.emergency_relationship1,
              Emergency_phone1: element.emergency_phone1,
              Emergency_name2: element.emergency_name2,
              Emergency_relationship2: element.emergency_relationship2,
              Emergency_phone2: element.emergency_phone2,
              // How_did_you_hear_about_us: element.hear_us,
              Referral_from_a_friend_or_family_member:
                element.referral_from_a_friend_or_family_member,
              notes: element.notes,
            });
          });
          const headings = [
            [
              "Couple Id",
              "His First Name",
              "His Last Name",
              "His Email",
              "His Mobile",
              "Her First Name",
              "Her Last Name",
              "Her Email",
              "Her Mobile",
              "Address",
              "City",
              "State",
              "Zip",
              "Parish",
              "Anniversary Date",
              "Dietary Restrictions Or Physical Limitations",
              "Under Age 35",
              "Emergency Name1",
              "Emergency Relationship1",
              "Emergency Phone1",
              "Emergency Name2",
              "Emergency Relationship2",
              "Emergency Phone2",
              "How did you hear about us?",
              "Referral from a friend/family member",
              "Notes",
            ],
          ];
          const wb = utils.book_new();
          const ws = utils.json_to_sheet([]);
          utils.sheet_add_aoa(ws, headings);
          utils.sheet_add_json(ws, exportData, {
            origin: "A2",
            skipHeader: true,
          });
          utils.book_append_sheet(wb, ws, "Data");
          writeFile(wb, "Couple Data.xlsx");
          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const exportPdf = async () => {
    const unit = "pt";
    const size = "A1"; // large page for wide data
    const orientation = "landscape"; // ✅ changed to landscape
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    const title = "All Couples";

    const headers = [
      [
        "Couple Id",
        "His First Name",
        "His Last Name",
        "His Email",
        "His Mobile",
        "Her First Name",
        "Her Last Name",
        "Her Email",
        "Her Mobile",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];

    let d = { userRole: "COUPLE" };
    d.pageNo = 1;
    d.size = 20;
    d.export = true;

    await adminApi
      .getAllCouples(d)
      .then(async (res) => {
        if (res.success) {
          const data = res.data.map((element) => [
            element.primaryKey,
            element.hisFirstName,
            element.hisLastName,
            element.hisEmail,
            element.hisMobile,
            element.herFirstName,
            element.herLastName,
            element.herEmail,
            element.herMobile,
            element.address,
            element.city,
            element.state,
            element.zip,
            element.parish,
            element.anniversary_date !== null
              ? Helpers.convertUtcToTimezone(
                  element.anniversary_date,
                  "MM-DD-YYYY",
                )
              : "",
            element.allergies,
            element.under_age_35,
            element.emergency_name1,
            element.emergency_relationship1,
            element.emergency_phone1,
            element.emergency_name2,
            element.emergency_relationship2,
            element.emergency_phone2,
            element.referral_from_a_friend_or_family_member,
            element.notes,
          ]);

          let content = {
            head: headers,
            body: data,
            startY: 70,
            theme: "grid",
            tableLineColor: [189, 195, 199],
            tableLineWidth: 0.75,
            styles: {
              fontSize: 9,
              cellPadding: 3,
              overflow: "linebreak",
              cellWidth: "wrap",
            },
            headStyles: {
              fillColor: [22, 160, 133],
              textColor: [255, 255, 255],
              fontSize: 9,
            },
            // ✅ Wider column widths for landscape layout
            columnStyles: {
              0: { cellWidth: 50 },
              1: { cellWidth: 70 },
              2: { cellWidth: 70 },
              3: { cellWidth: 120 },
              4: { cellWidth: 80 },
              5: { cellWidth: 70 },
              6: { cellWidth: 70 },
              7: { cellWidth: 120 },
              8: { cellWidth: 80 },
              9: { cellWidth: 100 },
              10: { cellWidth: 70 },
              11: { cellWidth: 50 },
              12: { cellWidth: 60 },
              13: { cellWidth: 70 },
              14: { cellWidth: 100 },
              15: { cellWidth: 70 },
              16: { cellWidth: 100 },
              17: { cellWidth: 100 },
              18: { cellWidth: 90 },
              19: { cellWidth: 100 },
              20: { cellWidth: 100 },
              21: { cellWidth: 90 },
              22: { cellWidth: 120 },
              23: { cellWidth: 130 },
              24: { cellWidth: 130 },
            },
            tableWidth: "wrap",
            margin: { left: marginLeft, right: 40 },
          };

          doc.text(title, marginLeft, 40);
          doc.autoTable(content);
          doc.save("report.pdf");

          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  function isXLSXFile(file) {
    return file.name.endsWith(".xlsx");
  }

  const fileChangeListener = (event) => {
    const text = [];
    let files = [];
    files = event.target.files;
    if (files && files.length && isXLSXFile(files[0])) {
      const input = event.target;
      const reader = new FileReader();
      reader.readAsBinaryString(input.files[0]);

      reader.onload = (e) => {
        const exportData = [];
        const xlsxData = reader.result;
        processXLSXCoupleRecord(xlsxData);
      };
      reader.onerror = function () {
        alert("Unable to read " + input.files[0]);
      };
    } else {
      toast.error("Please import valid .xlsx file.");
    }
  };

  const processXLSXCoupleRecord = (xlsxRecordsArray) => {
    try {
      const workbook = XLSX.read(xlsxRecordsArray, { type: "binary" });
      const sheet_name_list = workbook.SheetNames;
      const data = [];
      sheet_name_list.forEach(function (y) {
        const worksheet = workbook.Sheets[y];
        const headers = {};
        for (let z in worksheet) {
          if (z[0] === "!") continue;
          // parse out the column, row, and value
          let tt = 0;
          for (let i = 0; i < z.length; i++) {
            if (!isNaN(z[i])) {
              tt = i;
              break;
            }
          }
          const col = z.substring(0, tt);
          const row = parseInt(z.substring(tt));
          const value = worksheet[z].v;
          // store header names
          if (row == 1 && value) {
            headers[col] = value;
            continue;
          }
          if (!data[row]) {
            data[row] = {};
          }
          data[row][headers[col]] = value;
        }
      });

      if (data && data.length) {
        let importedData = [];
        // if (!data[2]["Couple Id"]) {
        //   toast.error("Couple Id Header is missing in Excel");
        //   // setProcessing(false);
        //   return false;
        // }
        data.forEach(function (value, index) {
          const obj = {};
          // if (value["Couple Id"] == '') {
          //   toast.error("Couple Id value missing. Check near line " + index + 1);
          //   // setProcessing(false);
          //   return false;
          // }
          if (value["Couple Id"]) {
            // && value["His Last Name"] && value["His Email"] && value["His Mobile"] && value["Her First Name"] && value["Her Last Name"] && value["Her Email"] && value["Her Mobile"]
            obj.primaryKey = value["Couple Id"];
            obj.hisFirstName = value["His First Name"]
              ? value["His First Name"]
              : "";
            obj.hisLastName = value["His Last Name"]
              ? value["His Last Name"]
              : "";
            obj.hisEmail = value["His Email"] ? value["His Email"] : "";
            obj.hisMobile = value["His Mobile"] ? value["His Mobile"] : "";

            obj.herFirstName = value["Her First Name"]
              ? value["Her First Name"]
              : "";
            obj.herLastName = value["Her Last Name"]
              ? value["Her Last Name"]
              : "";
            obj.herEmail = value["Her Email"] ? value["Her Email"] : "";
            obj.herMobile = value["Her Mobile"] ? value["Her Mobile"] : "";
            obj.address = value["Address"] ? value["Address"] : "";
            obj.city = value["City"] ? value["City"] : "";
            obj.state = value["State"] ? value["State"] : "";
            obj.zip = value["Zip"] ? value["State"] : "";
            obj.anniversary_date = value["Anniversary Date"]
              ? value["Anniversary Date"]
              : "";
            obj.allergies = value[
              "Dietary Restrictions Or Physical Limitations"
            ]
              ? value["Dietary Restrictions Or Physical Limitations"]
              : "";
            obj.under_age_35 = value["Under Age 35"]
              ? value["Under Age 35"]
              : "";
            obj.emergency_name1 = value["Emergency Name1"]
              ? value["Emergency Name1"]
              : "";
            obj.emergency_relationship1 = value["Emergency Relationship1"]
              ? value["Emergency Relationship1"]
              : "";
            obj.emergency_phone1 = value["Emergency Phone1"]
              ? value["Emergency Phone1"]
              : "";
            obj.emergency_name2 = value["Emergency Name2"]
              ? value["Emergency Name2"]
              : "";
            obj.emergency_relationship2 = value["Emergency Relationship2"]
              ? value["Emergency Relationship2"]
              : "";
            obj.emergency_phone2 = value["Emergency Phone2"]
              ? value["Emergency Phone2"]
              : "";

            obj.hear_us = value["How did you hear about us?"]
              ? value["How did you hear about us?"]
              : "";

            obj.referral_from_a_friend_or_family_member = value[
              "Referral from a friend/family member"
            ]
              ? value["referral from a friend/family member"]
              : "";

            obj.notes = value["Notes"] ? value["Notes"] : "";
            if (value["Parish"]) {
              const valParishStr = String(value["Parish"]).trim();
              let findParish = parishList.find(
                (i: any) =>
                  String(i.id) === valParishStr ||
                  (i.parish && i.parish.toLowerCase().trim() === valParishStr.toLowerCase())
              );
              if (findParish && findParish.id) {
                obj.parishId = findParish.id;
              } else {
                obj.parishId = null;
              }
            } else {
              obj.parishId = null;
            }
          } else {
            obj.primaryKey = "";
            obj.hisFirstName = value["His First Name"]
              ? value["His First Name"]
              : "";
            obj.hisLastName = value["His Last Name"]
              ? value["His Last Name"]
              : "";
            obj.hisEmail = value["His Email"] ? value["His Email"] : "";
            obj.hisMobile = value["His Mobile"] ? value["His Mobile"] : "";

            obj.herFirstName = value["Her First Name"]
              ? value["Her First Name"]
              : "";
            obj.herLastName = value["Her Last Name"]
              ? value["Her Last Name"]
              : "";
            obj.herEmail = value["Her Email"] ? value["Her Email"] : "";
            obj.herMobile = value["Her Mobile"] ? value["Her Mobile"] : "";
            obj.address = value["Address"] ? value["Address"] : "";
            obj.city = value["City"] ? value["City"] : "";
            obj.state = value["State"] ? value["State"] : "";
            obj.zip = value["Zip"] ? value["State"] : "";
            obj.anniversary_date = value["Anniversary Date"]
              ? value["Anniversary Date"]
              : "";
            obj.allergies = value[
              "Dietary Restrictions Or Physical Limitations"
            ]
              ? value["Dietary Restrictions Or Physical Limitations"]
              : "";
            obj.under_age_35 = value["Under Age 35"]
              ? value["Under Age 35"]
              : "";
            obj.emergency_name1 = value["Emergency Name1"]
              ? value["Emergency Name1"]
              : "";
            obj.emergency_relationship1 = value["Emergency Relationship1"]
              ? value["Emergency Relationship1"]
              : "";
            obj.emergency_phone1 = value["Emergency Phone1"]
              ? value["Emergency Phone1"]
              : "";
            obj.emergency_name2 = value["Emergency Name2"]
              ? value["Emergency Name2"]
              : "";
            obj.emergency_relationship2 = value["Emergency Relationship2"]
              ? value["Emergency Relationship2"]
              : "";
            obj.emergency_phone2 = value["Emergency Phone2"]
              ? value["Emergency Phone2"]
              : "";
            obj.hear_us = value["How did you hear about us?"]
              ? value["How did you hear about us?"]
              : "";
            obj.referral_from_a_friend_or_family_member = value[
              "Referral from a friend/family member"
            ]
              ? value["referral from a friend/family member"]
              : "";
            obj.notes = value["Notes"] ? value["Notes"] : "";
            if (value["Parish"]) {
              const valParishStr = String(value["Parish"]).trim();
              let findParish = parishList.find(
                (i: any) =>
                  String(i.id) === valParishStr ||
                  (i.parish && i.parish.toLowerCase().trim() === valParishStr.toLowerCase())
              );
              if (findParish && findParish.id) {
                obj.parishId = findParish.id;
              } else {
                obj.parishId = null;
              }
            } else {
              obj.parishId = null;
            }
          }
          importedData.push(obj);
        });
        saveCoupleExcel(importedData);
      }
    } catch (err) {
      toast.error(err.toString());
    }
    // setProcessing(false);
  };

  const saveCoupleExcel = async (importedData) => {
    const chunkSize = 10000;
    for (let i = 0; i < importedData.length; i += chunkSize) {
      const chunk = importedData.slice(i, i + chunkSize);
      await adminApi
        .saveCoupleExcel(chunk)
        .then(async (response) => {
          if (response.success) {
            let messages: string[] = [];
            if (response && response.mismatch && response.mismatch.length) {
              let arrayId = response.mismatch.join(",");
              messages.push(
                `These couples have mismatch records:\n${arrayId}\nSo, these records were not updated.`,
              );
            }
            if (
              response &&
              response.duplicateWithinFile &&
              response.duplicateWithinFile.length
            ) {
              let dupList = response.duplicateWithinFile
                .map(
                  (d: any) =>
                    `${d.hisFirstName || ""} & ${d.herFirstName || ""} (${d.reason || "Duplicate"})`,
                )
                .join(", ");
              messages.push(
                `The following couples were skipped as duplicates:\n${dupList}`,
              );
            }

            if (messages.length > 0) {
              setCoupleRepeatMsg(messages.join("\n\n"));
              setShow3(true);
            }

            const fileEl = document.getElementById(
              "fileUpload",
            ) as HTMLInputElement;
            if (fileEl) fileEl.value = "";
            getAllCouplesData(1, 20, "");
            checkPKCouple();
            toast.success("File data imported successfully");
            if (response.createdCouple && response.createdCouple.length > 0) {
              await Promise.all(
                response.createdCouple.map(async (item) => {}),
              );
            }
            if (response.updateCouple && response.updateCouple.length > 0) {
              await Promise.all(
                response.updateCouple.map(async (item) => {
                  if (item.oldherFirstName != item.newherFirstName) {
                  }

                  if (item.oldherLastName != item.newherLastName) {
                  }

                  if (item.oldherEmail != item.newherEmail) {
                  }

                  if (item.oldherMobile != item.newherMobile) {
                  }

                  if (item.oldhisFirstName != item.newhisFirstName) {
                  }

                  if (item.oldhisLastName != item.newhisLastName) {
                  }

                  if (item.oldhisEmail != item.newhisEmail) {
                  }

                  if (item.oldhisMobile != item.newhisMobile) {
                  }

                  if (item.oldcity != item.newcity) {
                  }

                  if (item.oldstate != item.newstate) {
                  }

                  if (item.oldzip != item.newzip) {
                  }

                  if (item.oldnotes != item.newnotes) {
                  }

                  if (item.oldparish != item.newparish) {
                  }

                  if (item.oldaddress != item.newaddress) {
                  }

                  if (item.oldallergies != item.newallergies) {
                  }

                  if (item.oldanniversary_date != item.newanniversary_date) {
                  }

                  if (item.oldhear_us != item.newhear_us) {
                  }

                  if (item.oldemergency_name1 != item.newemergency_name1) {
                  }

                  if (
                    item.oldemergency_relationship1 !=
                    item.newemergency_relationship1
                  ) {
                  }

                  if (item.oldemergency_phone1 != item.newemergency_phone1) {
                  }

                  if (item.oldemergency_name2 != item.newemergency_name2) {
                  }

                  if (
                    item.oldemergency_relationship2 !=
                    item.newemergency_relationship2
                  ) {
                  }

                  if (item.oldemergency_phone2 != item.newemergency_phone2) {
                  }

                  if (item.oldunder_age_35 != item.newunder_age_35) {
                  }

                  if (
                    item.oldreferral_from_a_friend_or_family_member !=
                    item.newreferral_from_a_friend_or_family_member
                  ) {
                  }
                }),
              );
            }
          } else {
            const fileEl = document.getElementById(
              "fileUpload",
            ) as HTMLInputElement;
            if (fileEl) fileEl.value = "";
            getAllCouplesData(1, 20, "");
            checkPKCouple();
            const errMsg = response.msg || "Failed to import couple data.";
            setCoupleRepeatMsg(errMsg);
            setShow3(true);
            toast.error(errMsg);
          }
        })
        .catch((error: any) => {
          const fileEl = document.getElementById(
            "fileUpload",
          ) as HTMLInputElement;
          if (fileEl) fileEl.value = "";
          const errMsg =
            error?.response?.data?.msg ||
            error?.message ||
            error?.toString() ||
            "An error occurred while importing data.";
          setCoupleRepeatMsg(errMsg);
          setShow3(true);
          toast.error(errMsg);
          console.error("There is an error!", error);
        });
    }
  };

  const clickOnInputFile = () => {
    document.getElementById("fileUpload").click();
  };

  const downloadSampleExcel = async () => {
    const headings = [
      [
        "Couple Id",
        "His First Name",
        "His Last Name",
        "His Email",
        "His Mobile",
        "Her First Name",
        "Her Last Name",
        "Her Email",
        "Her Mobile",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "How did you hear about us?",
        "Referral from a friend/family member",
        "Notes",
      ],
    ];
    const data = [
      {
        primaryKey: "0001",
        hisLastName: "Paul",
        hisFirstName: "Sam",
        hisEmail: "sampaul@gmail.com",
        hisMobile: "210-323-0384",
        herLastName: "Adams",
        herFirstName: "Charisse",
        herEmail: "charisseAdams@gmail.com",
        herMobile: "210-459-4955",
        address: "101 Balistreri Overpass, Cummerataland, KY 42976",
        city: "Los Angeles",
        state: "California",
        zip_code: "123456",
        parish: "Holy Spirit",
        ainniversary_date: "04-02-2000",
        dietary_restrictions_or_physical_limitations:
          "Dietary restrictions or physical limitations",
        under_age_35: "NO",
        emergency_name_1: "cris",
        emergency_relationship_1: "friend",
        emergency_phone_1: "6445-7645-6786",
        emergency_name_2: "Eric",
        emergency_relationship_2: "Brother",
        emergency_phone_2: "1425-7645-6786",
        hear_about_us: "School Marquee",
        Referral_from_a_friend_or_Family_member: "sister",
        notes: "Your notes here.",
      },
    ];
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, headings);
    utils.sheet_add_json(ws, data, { origin: "A2", skipHeader: true });
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, "Sample Couple File.xlsx");
    
  };

  return (
    <>
      <ManageCouplesHeaderActions
        isAdmin={userData?.userRole === "ADMIN"}
        onViewAll={() => getAllCouplesData()}
        onCreate={() => {
          setShowREgModal(true);
          checkPKCouple();
          clearfield();
        }}
        onFilterChange={handleSearchChanges}
      />
      <div className="row ext-space">
        <div className="col-lg-12 d-flex flex-column">
          <div className="row flex-grow">
            <div className="col-12 grid-margin stretch-card">
              <div className="card custom-card">
                <div className="card-body ">
                  <ManageCouplesToolbar
                    total={total}
                    searchKey={searchKey}
                    onSearch={SearchData}
                    isAdmin={userData?.userRole === "ADMIN"}
                    onDownloadSample={downloadSampleExcel}
                    onImportClick={clickOnInputFile}
                    onFileChange={fileChangeListener}
                    onExportExcel={handleExport}
                    onExportPdf={exportPdf}
                  />
                  <ResponsiveDataList
                    loading={LoadData}
                    data={allCoupleData}
                    columns={columns}
                    total={total}
                    countPerPage={20}
                    isServerSide
                    pagination
                    sortServer
                    dataFetchApi={(pageNo, size, _search, sortBy, _sel, parishValue) =>
                      getAllCouplesData(
                        pageNo,
                        size,
                        searchKey || null,
                        sortBy || {},
                        false,
                        parishValue ?? locationData?.state?.parishValue,
                      )
                    }
                    conditionalRowStyles={conditionalRowStyles}
                    pointerOnHover
                    highlightOnHover
                    parishValue={locationData?.state?.parishValue}
                    forCouple
                    cardGridColumns={{ xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }}
                    renderCard={(row) => (
                      <CoupleCard
                        row={row}
                        isAdmin={userData?.userRole === "ADMIN"}
                        onEdit={(r) => {
                          editCouple(r.id);
                          setShowREgModal(true);
                          getroastersOfCouple(r.id);
                        }}
                        onDelete={handleShow}
                        onStatusChange={changeStatus}
                        onToggleSubAdmin={handleShow1}
                        onToggleSuperAdmin={handleShow2}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {show ? (
          <DeleteModel
            show={show}
            content={
              <>
                <h5 className="mt-4 fw-bold">Couple Detail</h5>
                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  {/* His Details */}
                  {(icon_id.hisFirstName ||
                    icon_id.hisLastName ||
                    icon_id.hisEmail) && (
                    <div className="mb-2">
                      <span className="fw-bold">His:</span>{" "}
                      {icon_id.hisFirstName} {icon_id.hisLastName}
                      {icon_id.hisEmail && (
                        <span className="text-muted">
                          {" "}
                          – {icon_id.hisEmail}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Her Details */}
                  {(icon_id.herFirstName ||
                    icon_id.herLastName ||
                    icon_id.herEmail) && (
                    <div>
                      <span className="fw-bold">Her:</span>{" "}
                      {icon_id.herFirstName} {icon_id.herLastName}
                      {icon_id.herEmail && (
                        <span className="text-muted">
                          {" "}
                          – {icon_id.herEmail}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </>
            }
            handleClose={handleClose}
            DeleteData={deleteCouple}
          ></DeleteModel>
        ) : null}
        {show1 ? (
          <AlertModal
            show={show1}
            handleClose={handleClose1}
            message={`Are you sure you want to ${
              changeText && changeText !== "" ? changeText : "make"
            } this couple as sub-admin?`}
            actionFunction={makeCoupleAsSubAdmin}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}
        {show2 ? (
          <AlertModal
            show={show2}
            handleClose={handleClose2}
            message={`Are you sure you want to ${
              changeText && changeText !== "" ? changeText : "make"
            } this couple as super-admin?`}
            actionFunction={makeCoupleAsSubAdmin}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}
        {showRegModal ? (
          <UpdateCouplePopUp
            showRegModal={showRegModal}
            setShowREgModal={setShowREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKCouple();
              setEdiUserIdClicked("");
              CloseCompose();
              getAllCouplesData();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfCoupleList={roastersOfCoupleList}
            getAllCouples={getAllCouplesData}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            // isTempUpload2={isTempUpload2}
            setIsTempUpload={setIsTempUpload}
            // setIsTempUpload2={setIsTempUpload2}
          />
        ) : null}

        {/* {showPriestREgModal ? (
          <UpdatePriestPopUp
            showRegModal={showPriestREgModal}
            setShowREgModal={setShowPriestREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKCouple();
              setEdiUserIdClicked("");
              CloseCompose();
              getAllCouplesData();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfCoupleList={roastersOfCoupleList}
            getAllCouples={getAllCouplesData}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            // isTempUpload2={isTempUpload2}
            setIsTempUpload={setIsTempUpload}
            // setIsTempUpload2={setIsTempUpload2}
          />
        ) : null} */}

        {show3 ? (
          <AlertModal
            show={show3}
            handleClose={handleClose3}
            message={coupleRepeatMsg}
            actionFunction={handleClose3}
            cancel={"Cancel"}
            heading={"ALERT!!"}
            okay={"Okay"}
          />
        ) : null}
      </div>
    </>
  );
};

export default ManageCouples;
